import React from 'react'
import {Box, Card, CardContent, Typography} from '@mui/material'
import {GridRowModel} from '@mui/x-data-grid'
import {FrequencyNameMapping} from '../../../domain/Frequency'
import {AmountWithEuro} from '../../AmountWithEuro'

type RecurrenceCardProps = {
  row: GridRowModel,
  onEdit: () => void,
}

export const RecurrenceCard: React.FC<RecurrenceCardProps> = ({row, onEdit}) => {
  const frequencyLabel = FrequencyNameMapping[row.frequency] ?? ''
  return (
    <Card variant="outlined" sx={{mb: 1}} data-testid="recurrence-card" onClick={onEdit}>
      <CardContent sx={{cursor: 'pointer', '&:last-child': {pb: 2}}}>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography sx={{fontWeight: 500}}>{row.description}</Typography>
          <AmountWithEuro amount={row.amount}/>
        </Box>
        <Typography variant="body2" color="text.secondary">{frequencyLabel}</Typography>
      </CardContent>
    </Card>
  )
}
